export default "__VITE_ASSET__UldZlDNe__"